/*
 *
 *  UI Store
 */

// state
const state = {
  // guide title
  guideReveal: false,
  guide: {}
}

// getters
const getters = {
  // guide title
  getGuide: state => {
    return state.guide
  },
  // guide title reveal
  getGuideReveal: state => {
    return state.guideReveal
  }
}

// actions
const actions = {}

// mutations
const mutations = {
  // set guide title
  setGuide(state, title) {
    state.guideReveal = false
    setTimeout(() => {
      state.guide = title
      if (title) {
        setTimeout(() => {
          state.guideReveal = true
        }, 5)
      }
    }, 250)
  }
}

// export
export default {
  state,
  getters,
  actions,
  mutations
}
